import { render, staticRenderFns } from "./tiptap-input.vue?vue&type=template&id=07305ce3&scoped=true&lang=pug&"
import script from "./tiptap-input.vue?vue&type=script&lang=js&"
export * from "./tiptap-input.vue?vue&type=script&lang=js&"
import style0 from "./tiptap-input.vue?vue&type=style&index=0&id=07305ce3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07305ce3",
  null
  
)

export default component.exports